import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { IUserPlanState, IUserPlanRequestsState, UserPlanRequestStatus } from '@/creditflowresearch/application/User/UserPlan/types';

export const initialRequests: IUserPlanRequestsState = {
  [UserPlanType.UNAUTHORIZED]: {
    plan: UserPlanType.UNAUTHORIZED,
    status: UserPlanRequestStatus.Denied,
  },
};

export const initUserPlan: IUserPlanState = {
  plan: UserPlanType.UNAUTHORIZED,
  features: [],
  regions: [],
  products: [],
  requests: initialRequests,
  preferences: null,
  role: null,
};

export const mapUserPlanToSubscribeDescription = {
  [UserPlanType.STARTER]: '<strong>Starter</strong> and <strong>Professional</strong> plans',
  [UserPlanType.PREMIUM]: '<strong>Professional</strong> plans',
  [UserPlanType.PRO]: '<strong>Professional</strong> plan',
} as const;
